import * as API from "@/api/index.js"
import {Terminal} from 'xterm'  // 初始化组件
import {AttachAddon} from 'xterm-addon-attach'
import {FitAddon} from 'xterm-addon-fit'

export default {
  name: "websocket-terminal",
  components: {},

  props: {
    disable_stdin: {  //是否禁用输入
      type: Boolean,
      default: false,
    },

    auto_init: {   // 是否自动初始化
      type: Boolean,
      default: true,
    }

  },


  data() {
    return {
      ws_id: "",
      ws_url: "",
      ws: "",

      target_term: null,
      term_init_param: {
        convertEol: true, //启用时，光标将设置为下一行的开头
        scrollback: 1000, //终端中的回滚量
        disableStdin: false, //是否禁用输入
        cursorStyle: "underline", //光标样式   underline / block / bar
        cursorBlink: true, //光标闪烁
        theme: {
          foreground: "#D3D5D7", //字体
          background: "#060101", //背景色
          cursor: "help" //设置光标
        },
        logLevel: "info",
        fontSize: 12,
      },
      cell_width: null,
      cell_height: null,
    }
  },

  mounted() {

    if (!this.target_term && this.auto_init) {
      this.$nextTick(() => {
        this.init_xterm();
        this.get_ws_id_req((ws_id) => {
          this.init_ws(ws_id);
        });
      })
    }
  },

  beforeDestroy() {
    this.close_term()
  },

  methods: {

    // 初始化xterm
    init_xterm() {
      if (this.target_term) return;
      let _this = this;
      // 初始化 xterm
      this.term_init_param.disableStdin = this.disable_stdin;
      this.target_term = new Terminal(this.term_init_param);

      this.target_term.fitAddon = new FitAddon();
      this.target_term.loadAddon(this.target_term.fitAddon);

      const term_dom = this.$el;
      console.log(term_dom)
      // 创建terminal实例
      this.target_term.open(term_dom);

      console.log('mounted is going on');
      this.target_term.fitAddon.fit();  // 自适应宽高

      this.target_term.focus();

      function runFakeTerminal(_this) {
        if (_this.target_term._initialized) {
          return;
        }
        // 初始化
        _this.target_term._initialized = true;

        // 支持输入与粘贴方法
        _this.target_term.onData(function (key) {
          if (!_this.cell_width || !_this.cell_height) {
            _this.resize_term()     // 向服务端发送行列数，适应屏幕大小
          }

          //这里key值是输入的值
          _this.on_send(key);

        });
      }

      runFakeTerminal(_this);
      this.target_term.writeln("started...");
    },

    // 发送数据
    on_send(data) {
      let datas = {
        data: data,
      };
      this.ws.send(JSON.stringify(datas));

    },

    // 发送行列数据
    on_resize(data) {
      let datas = {
        resize: data,
      };
      // this.ws.send(JSON.stringify(datas));
    },

    // 自适应屏幕
    fit_screen() {
      this.target_term.fitAddon.fit();
    },

    // 获取终端字符宽度 高度
    get_cell_size(term) {
      this.cell_width = term._core._renderService._renderer.dimensions.actualCellWidth;
      this.cell_height = term._core._renderService._renderer.dimensions.actualCellHeight;
      return {"width": this.cell_width, "height": this.cell_height};
    },

    // 终端行列数
    resize_term(term_box_dom) {
      if (!term_box_dom) {
        term_box_dom = this.$el.parentElement
      }
      var cell_size = this.get_cell_size(this.target_term);

      var cols = parseInt(term_box_dom.clientWidth / cell_size.width, 10) - 1;
      var rows = parseInt(term_box_dom.clientHeight / cell_size.height, 10);
      var resize_data = String(cols) + "," + String(rows);
      console.log(resize_data);
      this.on_resize(resize_data);
    },

    // 清屏
    clear_screen() {
      if (this.target_term) {
        this.target_term.clear()
      }
    },

    init_ws(ws_id, type) {
      ws_id = ws_id || this.ws_id;
      if (!ws_id) return;
      let href = this.get_href();
      this.ws_url = `${href}/websocket_log/${ws_id}`;
      console.log(this.ws_url);
      this.ws = new WebSocket(this.ws_url);

      this.ws.onopen = (evt) => this.ws_on_open(evt, type);    // websocket 连接建立

      this.ws.onmessage = (evt) => this.ws_on_message(evt);   // 	websocket 客户端接收服务端数据时触发

      this.ws.onclose = function (evt) {
        // 关闭 websocket
        var msg = "Web Socket 连接已关闭... ";
        if (!evt.wasClean) {
          msg = "Web Socket 连接异常关闭 ";
        }
        console.log(msg + new Date().toLocaleString(), evt);
      };

      this.ws.onerror = function (evt) {
        console.error("WebSocket error observed:", evt);
      }
    },

    // 注销并重新连接 websocket
    reconnect_ws() {
      console.log("Web Socket 注销并重新连接")
      if (this.ws) {
        this.ws.close()
      }

      this.init_ws(this.ws_id, "reconn")

    },

    get_href() {
      let location_href = window.location.host
      let protocol = window.location.protocol
      let href_start = "ws://"
      if (this.$_startsWith("https", protocol)) {
        href_start = "wss://"
      }
      return href_start + location_href
    },

    // websocket连接建立事件
    ws_on_open(evt, type) {
      console.log("Web Socket 已连接 " + new Date().toLocaleString());
      if (((!this.cell_width || !this.cell_height) || type == 'reconn') && this.target_term) {
        this.resize_term()     // 向服务端发送行列数，适应屏幕大小
      }
      this.$emit("ws_init_success", this.ws_id)
    },

    // websocket客户端接收服务端数据事件
    ws_on_message(evt) {
      if (!this.target_term) return;
      let received_msg = JSON.parse(evt.data);
      if (String(received_msg.code) === "2") {
        console.log(received_msg.msg + new Date().toLocaleString());
        this.$emit("ws_closed");
        return
      }
      this.target_term.write(received_msg.time + "：");
      this.target_term.writeln(received_msg.msg);
      this.$emit("ws_msg_received", received_msg);
    },

    async get_ws_id_req(callback) {
      let response = await API.GET("/websocket_log_auth/");
      let data = response.data;
      if (data.success) {
        this.ws_id = data.data;
        this.$emit("ws_id_init", this.ws_id);
        if (callback) callback(data.data);
      } else {
        this.$message.error(data.msg);
      }
    },


    // 关闭xterm  关闭websocket连接
    close_term() {
      if (this.target_term) {
        this.target_term.dispose()
        this.target_term = ""
        console.log("term is close")
      }
      if (this.ws) {
        this.ws.close()
      }

    },

  }

}



// WEBPACK FOOTER //
// ./src/omnis-business/websocket-terminal/websocket-terminal.js